import { Component, Input, Directive } from '@angular/core';
import { BasicChartsDirective } from '../directives/basic-charts';

@Component({
  selector: 'basic-chart',
  template: `<div style="width:100%;height:100%">
                  <canvas
                        id="{{chartId}}"
                        [chart-type]="chartType"
                        [chart-data]="chartData"
                        [chart-options]="chartOptions"
                        style="width:100% !important;height:100% !important;">
                  </canvas>
            </div>`
})
export class BasicChartComponent {
  @Input() public chartType: any = null;
  @Input() public chartData: any;
  @Input() public chartOptions: any;
  @Input() public chartId = 'basicChart';
}



// WEBPACK FOOTER //
// ./src/common/charts/components/basic-charts.component.ts